<template>
  <a-modal
    title='可视化图表'
    :visible='visible'
    :confirm-loading='confirmLoading'
    @ok='handleOk'
    @cancel='handleCancel'
    width='800'
  >
    <div class='bigbox'>
      <div class='productNamecust'>
        <div style='margin-left: 5px'><h2>产品名称：{{ productName }}</h2></div>
        <div style='margin-left: 5px' v-show='showDayTitle'><h2>日期：{{ startTime }}</h2></div>
        <div class='custContentbox2'
             style='display: flex;flex-direction: column;justify-content: space-around;'>
          <div class='cust-chart-one' style='width:96%; height: 800px; margin-bottom: 100px'></div>
          <div class='cust-chart-two' style='width:96%; height: 800px;'></div>
        </div>
      </div>
    </div>
  </a-modal>
</template>

<script>
import { getConvertData } from '@/webpublicapi/order'

export default {
  data() {
    return {
      visible: false,
      confirmLoading: true,
      showDayTitle: false,//只有一天数据的时候展示日期 默认false
      productName: '产品名',
      startTime: '',
      endTime: '',
      VersionArr: [],//版本号
      VersionDataArr: [],//版本号及对应数组数据
      VersionPercentDataArr: []//版本号及对应百分比数据
    }
  },
  created() {
    console.log('created')
  },
  mounted() {
    this.confirmLoading = true
  },
  methods: {
    clearEcharts() {
      console.log('清空echartsvbv')
      const clearDom = document.querySelector('.cust-chart-one')
      const clearDom2 = document.querySelector('.cust-chart-two')
      console.log('clearDom--->', clearDom)
      console.log('clearDom2--->', clearDom2)
      if (!(clearDom || clearDom2)) {
        console.log('不清空')
      } else {
        console.log('清空')
        this.$echarts.init(document.querySelector('.cust-chart-one')).clear()
        this.$echarts.init(document.querySelector('.cust-chart-two')).clear()
      }
      console.log('清空echarts')
    },
    openModal() {
      console.log('open')
      this.visible = true
    },
    handleOk() {
      this.visible = false
    },
    handleCancel() {
      this.visible = false
    },
    //计算利率的方法
    calculateRate(a, b) {
      if (a === 0 || b === 0) {
        return 0 + '%'
      } else if (b === 0) {
        console.log('除数为0啦救救我！！')
        // return '-'
        return 0 + '%'
      } else {
        return (a / b * 100).toFixed(2) + '%'
      }
    },
    //请求图的数据
    sendRequest(query) {
      console.log('准备发请求的参数', query)
      // 发送请求的逻辑
      query.pageSize = 100
      getConvertData(query).then((res) => {
        console.log('getConvertData的res', res)
        if (res.code === 1000) {
          this.confirmLoading = false
          //获取产品名字
          this.productName = res.data.rows[0].appName
          const datalist = res.data.rows

          console.log('准备处理的数据-->', datalist)
          //选择一天---->时间
          this.startTime = datalist[datalist.length - 1].dataDt
          // console.log(' this.startTime ', this.startTime)
          //存储各个版本数据的数组
          // const versionListData = (datalist.map(datalist => datalist.dataDetails))
          datalist[0].appVersion = '总计'
          const versionListData = datalist[0].dataDetails
          console.log('存储各个版本数据的数组----->', versionListData)
          versionListData.unshift(datalist[0]) //在头部插入
          console.log('存储各个版本数据+总计的数组----->', versionListData)
          /*算利率开始*/
          versionListData.forEach(obj => {
            // 发短信率
            obj.installsOptRate = this.calculateRate(obj.optCount, obj.installs)
            //注册率
            obj.optRegRate = this.calculateRate(obj.regCount, obj.optCount)
            // 联系人率
            obj.workLinkmanRate = this.calculateRate(obj.linkmanCount, obj.regCount)
            // 银行卡信息率
            obj.idNoBankcardRate = this.calculateRate(obj.bankcardCount, obj.linkmanCount)
            // 身份证照片率
            obj.jsonIdimageRate = this.calculateRate(obj.idimageCount, obj.bankcardCount)
            //人脸照片率
            obj.idimageFaceRate = this.calculateRate(obj.faceCount, obj.bankcardCount)
            //身份证信息率
            obj.faceidNoRate = this.calculateRate(obj.idnoCount, obj.bankcardCount)
            // JSON率
            obj.linkedManJsonRate = this.calculateRate(obj.jsonCount, obj.idnoCount)
            // 基本信息率
            obj.regBasicRate = this.calculateRate(obj.basicCount, obj.jsonCount)
            // 工作信息率
            obj.basicWorkRate = this.calculateRate(obj.workCount, obj.basicCount)
            // 授信数量率
            obj.creditQuantityRate = this.calculateRate(obj.creditGrantedCount, obj.workCount)
            //申请率
            obj.bankcardApplyRate = this.calculateRate(obj.applyCount, obj.creditGrantedCount)
            //决策数量率
            obj.decisionsCountRate= this.calculateRate(obj.decisionsCount, obj.applyCount)
            // 过件率
            obj.applyAccessRate = this.calculateRate(obj.accessCount, obj.decisionsCount)
            //放款率
            obj.accessLoanRate = this.calculateRate(obj.loanCount, obj.accessCount)
            //注册-授信转化率
            obj.regBankCardRate = this.calculateRate(obj.creditGrantedCount, obj.regCount)
            //注册-申请转化率
            obj.regApplyRate = this.calculateRate(obj.applyCount, obj.regCount)
            // 申请-放款转化率
            obj.applyLoanRate = this.calculateRate(obj.loanCount, obj.applyCount)
            //注册-放款转化率
            obj.regLoanRate = this.calculateRate(obj.loanCount, obj.regCount)

          })
          /*算利率结束*/
          console.log('计算利率后的数组----->', versionListData)
          this.VersionArr = versionListData.map(obj => obj.appVersion) //map不改变原数组
          // console.log('存储版本名称的数组----->', this.VersionArr)
          //把总计放在版本数组的最后一个
          // this.VersionArr.push('总计')
          console.log('存储版本名称的数组+统计----->', this.VersionArr)
          this.VersionDataArr = versionListData.reduce((acc, curr) => {
            const {
              appVersion,
              installs,
              optCount,
              regCount,
              linkmanCount,
              bankcardCount,
              idimageCount,
              faceCount,
              idnoCount,
              jsonCount,
              basicCount,
              workCount,
              creditGrantedCount,
              applyCount,
              decisionsCount,
              accessCount,
              loanCount
            } = curr
            if (!acc[appVersion]) {
              acc[appVersion] = [
                installs,
                optCount,
                regCount,
                linkmanCount,
                bankcardCount,
                idimageCount,
                faceCount,
                idnoCount,
                jsonCount,
                basicCount,
                workCount,
                creditGrantedCount,
                applyCount,
                decisionsCount,
                accessCount,
                loanCount]
            }
            return acc
          }, {})
          console.log('数值:版本以及版本对应数据---->', this.VersionDataArr)


          const percentArr = versionListData.reduce((acc, curr) => {
            const {
              appVersion,
              installsOptRate,
              optRegRate,
              workLinkmanRate,
              idNoBankcardRate,
              jsonIdimageRate,
              idimageFaceRate,
              faceidNoRate,
              linkedManJsonRate,
              regBasicRate,
              basicWorkRate,
              creditQuantityRate,
              bankcardApplyRate,
              decisionsCountRate,
              applyAccessRate,
              accessLoanRate,
              regBankCardRate,
              regApplyRate,
              applyLoanRate,
              regLoanRate
            } = curr
            if (!acc[appVersion]) {
              acc[appVersion] = [
                installsOptRate,
                optRegRate,
                workLinkmanRate,
                idNoBankcardRate,
                jsonIdimageRate,
                idimageFaceRate,
                faceidNoRate,
                linkedManJsonRate,
                regBasicRate,
                basicWorkRate,
                creditQuantityRate,
                bankcardApplyRate,
                decisionsCountRate,
                applyAccessRate,
                accessLoanRate,
                regBankCardRate,
                regApplyRate,
                applyLoanRate,
                regLoanRate
              ]
            }
            return acc
          }, {})
          console.log('百分比:版本以及版本对应数据---->', percentArr)
          this.VersionPercentDataArr = Object.fromEntries(
            Object.entries(percentArr).map(([key, value]) => {
              const newValue = value.map(item => parseFloat(item, 10))
              return [key, newValue]
            })
          )
          console.log('去掉百分号-->', this.VersionPercentDataArr)

          this.drawOneDay()
        }
      }).catch(e => {

      })
    },
    //一天的画法
    drawOneDay() {
      console.log('调用了1天画图的方法')
      this.showDayTitle = true
      /*-----------------------------------------------------------数值图---------------------------------------------------------*/
      var chartDom = document.querySelector('.cust-chart-one')
      console.log('chartDom', chartDom)
      var myChart = this.$echarts.init(chartDom)
      var option
      var dataMap = {}

      function dataFormatter(obj) {
        var pList = ['安装', '发送注册OTP号码数', '注册', '联系人', '银行卡信息', '身份证照片', '人脸照片', '身份证信息', '大JSON','基本信息', '工作信息', '授信数量', '申请','决策数量', '过件', '放款']
        return obj
      }

      //单个产品的各个小版本的数据
      // dataMap.dataVersion = dataFormatter({
      //   //max : 60000,
      //   '1.0.6': [16251.93, 11307.28, 24515.76, 11237.55, 14359.88, 22226.7, 10568.83, 12582, 19195.69, 49110.27, 32318.85, 15300.65, 17560.18, 11702.82, 45361.85, 26931.03, 19632.26, 19669.56, 53210.28, 11720.87, 2522.66, 10011.37, 21026.68, 5701.84, 8893.12, 605.83, 12512.3, 5020.37, 1670.44, 2102.21, 6610.05],
      //   '1.0.4': [14113.58, 9224.46, 20394.26, 9200.86, 11672, 18457.27, 8667.58, 10368.6, 17165.98, 41425.48, 27722.31, 12359.33, 14737.12, 9451.26, 39169.92, 23092.36, 15967.61, 16037.96, 46013.06, 9569.85, 2064.5, 7925.58, 17185.48, 4602.16, 7224.18, 507.46, 10123.48, 4120.75, 1350.43, 1689.65, 5437.47]
      // })
      dataMap.dataVersion = dataFormatter(this.VersionDataArr)

      const showtite = this.VersionArr.map(item => ({
        title: { text: item !== '总计' ? '版本号:' + item : item },
        series: [
          { data: dataMap.dataVersion[item] }
        ]
      }))

      // console.log('showtite--->', showtite)
      option = {
        baseOption: {
          timeline: {
            // top: '50px',
            axisType: 'category',
            autoPlay: false,
            playInterval: 2000,
            //存储小版本号的数组
            data: this.VersionArr,
            label: {
              normal: {
                textStyle: {
                  fontSize: 14
                }
              },
              emphasis: {
                textStyle: {
                  fontSize: 14
                }
              }
            }
          },
          tooltip: {
            formatter: function(params) {
              // console.log('params--->', params)
              return params[0].marker + ' ' + params[0].axisValueLabel + ' ' + params[0].value
            }
          },
          legend: {
            left: 'right',
            // data: [this.productName],
            selected: {},
            textStyle: {
              fontSize: 16
            }

          },
          calculable: true,
          grid: {
            top: 80,
            bottom: 100,
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'shadow',
                label: {
                  show: true,
                  formatter: function(params) {
                    return params.value.replace('\n', '')
                  }
                }
              }
            }
          },
          xAxis: [
            {
              type: 'category',
              axisLabel: { interval: 0, fontSize: 14 },
              data: [
                '安装',//installs
                '发送注册OTP号码数',//optCount
                '注册',//regCount
                '联系人',//linkmanCount
                '银行卡信息',//bankcardCount
                '身份证照片',//idimageCount
                '人脸照片',//faceCount
                '身份证信息',//idnoCount
                '大JSON',//jsonCount
                '基本信息',//basicCount
                '工作信息',//workCount
                '授信数量',//creditGrantedCount
                '申请',//applyCount
                '决策数量',//decisionsCount
                '过件',//accessCount
                '放款'//loanCount
              ],
              splitLine: { show: false }
            }
          ],
          yAxis: {
            axisLabel: {
              fontSize: 18
            }
          },
          series: [
            {
              name: this.productName,
              type: 'bar',
              label: {
                position: 'top', // 标签位置
                show: true,
                color: 'red', // 文字颜色
                formatter: function(params) {
                  if (params.value == 0.00 || params.value == 0) {
                    return '{a|' + params.value + '}'
                  } else {
                    return '{b|' + params.value + '}'
                  }
                },
                rich: {
                  a: {
                    color: 'red',
                    fontSize: 18,
                    align: 'center'
                  },
                  b: {
                    color: 'black',
                    fontSize: 16,
                    align: 'center'
                  }


                }
              }
            }
          ]
        },
        //小版本号标题变化
        options: showtite
      }
      option && myChart.setOption(option)
      /*--------------------------------------------------------百分比图-------------------------------------------------------*/
      var chartDom2 = document.querySelector('.cust-chart-two')
      console.log('chartDom2', chartDom2)
      var myChart2 = this.$echarts.init(chartDom2)
      var option2
      var dataMap2 = {}

      function dataFormatter2(obj) {
        var pList = ['发短信率', '注册率', '联系人率', '银行卡信息率', '身份证照片率', '人脸照片率', '身份证信息率', 'JSON率','基本信息率',  '工作信息率','授信数量率','申请率','决策数量率', '过件率', '放款率', '注册-授信转化率', '注册-申请转化率', '申请-放款转化率', '注册-放款转化率']
        return obj
      }

      dataMap2.dataVersion = dataFormatter2(this.VersionPercentDataArr)

      const showtite2 = this.VersionArr.map(item => ({
        title: { text: item !== '总计' ? '版本号 : ' + item : item },
        series: [
          { data: dataMap2.dataVersion[item] }
        ]
      }))

      option2 = {
        baseOption: {
          timeline: {
            axisType: 'category',
            autoPlay: false,
            playInterval: 2000,
            //存储小版本号的数组
            data: this.VersionArr,
            label: {
              normal: {
                textStyle: {
                  fontSize: 14
                }
              },
              emphasis: {
                textStyle: {
                  fontSize: 14
                }
              }
            }
          },
          tooltip: {
            formatter: function(params) {
              // console.log('params--->', params)
              return params[0].marker + ' ' + params[0].axisValueLabel + ' ' + params[0].value + '%'
            }
          },
          legend: {
            left: 'right',
            // data: [this.productName],
            selected: {},
            textStyle: {
              fontSize: 16
            }
          },
          calculable: true,
          grid: {
            top: 80,
            bottom: 100,
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'shadow',
                label: {
                  show: true,
                  formatter: function(params) {
                    return params.value.replace('\n', '')
                  }
                }
              }
            }
          },
          xAxis: [
            {
              type: 'category',
              axisLabel: { interval: 0, fontSize: 14 },
              data: [
                '发短信率', '注册率', '联系人率', '银行卡信息率', '身份证照片率', '人脸照片率', '身份证信息率', 'JSON率', '基本信息率', '工作信息率','授信数量率', '申请率','决策数量率', '过件率', '放款率', '注册-授信转化率', '注册-申请转化率', '申请-放款转化率', '注册-放款转化率'
              ],
              splitLine: { show: false }
            }
          ],
          // yAxis: [
          //   {}
          // ],]
          yAxis: {
            type: 'value',
            axisLabel: {
              fontSize: 18,
              formatter: function(value) {
                return value + '%'
              }
            }
          },
          series: [
            {
              name: this.productName,
              type: 'bar',
              label: {
                position: 'top', // 标签位置
                show: true,
                color: 'red', // 文字颜色
                formatter: function(params) {
                  if (params.value == 0.00 || params.value == 0) {
                    return '{a|' + params.value + '%' + '}'
                  } else {
                    return '{b|' + params.value + '%' + '}'
                  }
                },
                rich: {
                  a: {
                    color: 'red',
                    fontSize: 16,
                    align: 'center'
                  },
                  b: {
                    color: 'black',
                    fontSize: 14,
                    align: 'center'
                  }


                }
              }

            }
          ]
        },
        //小版本号标题变化
        options: showtite2
      }
      option2 && myChart2.setOption(option2)
    }
  }
}
</script>

<style>
</style>